import { hc } from 'hono/client'

import type { App } from '../../worker/index.js'

/** Type-safe Hono RPC client for the wallet worker API. */
export const api = hc<App>('/')
export type Api = typeof api
